import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './icon-close.png'


const _withScopeId = n => (_pushScopeId("data-v-97ad179c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-notice-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "popup-content" }

interface IEmits {
    (event: 'close', closeType: 'common' | 'day'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (event: 'close', closeType: 'common' | 'day'): void;
  }), expose: any, slots: any, attrs: any }) {

  

  function closeForADay() {
    emits('close', 'day');
  }

  function close() {
    emits('close', 'common');
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "popup-header" }, [
      _createElementVNode("div", {
        class: "d-none d-md-block button-close",
        onClick: close
      }, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", { class: "d-block d-md-none" }, [
      _createElementVNode("div", { class: "popup-footer-mobile" }, [
        _createElementVNode("div", {
          class: "button",
          onClick: closeForADay
        }, " 오늘 하루 보지 않기 "),
        _createElementVNode("div", {
          class: "button",
          onClick: close
        }, " 닫기 ")
      ])
    ]),
    _createElementVNode("div", { class: "d-none d-md-block" }, [
      _createElementVNode("div", { class: "popup-footer-pc" }, [
        _createElementVNode("div", {
          class: "button",
          onClick: closeForADay
        }, " 오늘 하루 보지 않기 ")
      ])
    ])
  ]))
}
}

})